import React from 'react';
import './footer.scss';

const Footer = (props) => {

    return (
        <div className="footer-container">
            <div className="three-item_row">
                <div className="footer-item">
                    <h4 className="item-header">
                        Contact Details
                    </h4>
                    <div className="footer-email">
                        <a tabIndex="-1" href={`mailto:${props.config.contact}`}>{props.config.contact}</a>
                    </div>
                    <div className="mt-4">
                        <a tabIndex="-1" href={`mailto:${props.config.contact}`}
                           className="contact-us_button">Contact Us
                        </a>
                    </div>

                </div>
                <div className="footer-item">
                    <h4 className="item-header">
                    </h4>
                    <div className="footer-link">
                    </div>
                </div>
                <div className="footer-item">
                    <h4 className="item-header">
                        Important Links
                    </h4>
                    <div className="footer-link">
                        <a tabIndex="-1" href="/terms-of-service">Terms of Use</a>
                        <a tabIndex="-1" href="/privacy-policy">Privacy Policy</a>
                        <a tabIndex="-1" href="/advertising-disclosure">Advertising Disclosure</a>
                    </div>
                </div>
            </div>
            <div className="disclaimer">
                Payment Term: If you borrow $5,000 on a 3 year repayment term and at a 10% APR, the monthly repayment
                will be $161.34. Total repayment will be $5,808.24. Total interest paid will be $808.24.
                <br/>
                Disclaimer: The Annual Percentage Rate is the rate at which your loan accrues interest. It is based upon
                the amount of your loan, cost of the loan, term of the loan, repayment amounts and timing of payments
                and payoff. By law, the lender and/or lending partner must show you the APR before you enter into the
                loan. States have laws limiting the APR that the lender and/or lending partner can charge you. Rates
                will vary based on your credit, loan size and whether collateral is provided, with the lowest rates
                available to customers with good credit on larger, secured loans. Minimum and maximum loan amounts and
                APR may vary according to state law and lender or partners. We recommend you read the lender’s and/or
                lending partner’s personal terms and conditions in full before proceeding for a personal loan.
            </div>
            <div className="copyright-container">
                <div className="content-container">
                    <div className="copyright-content">
                        <div className="copyright">
                            Licenses and Disclosures | © {new Date().getFullYear()} {props.config.name}, Inc. All Rights Reserved.
                        </div>
                        <div className="footer-logo"/>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Footer;
